import {Form, Modal,  App,  Row, Col, Space   } from 'antd'
import { ASSETS_APPLICATION_BASE } from '../../config/api'
import React, { useEffect,useState } from 'react'
import classes from './expenseInvoice.module.css'
import { useFypdjUpdateSaveMutation, useFypdjUpdateQuery } from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';
import ExpenseListWithId from '../../document/expense/ExpenseListWithId'
import ReportDeptSelect from '../../system/dept/DeptSelect'
import OCRTextArea from '../../cpn/OCRTextArea'
import UploadPic from '../../cpn/UploadPic'
import DocumentRule from '../../cpn/DocumentRule'
import Asterisk from '../../cpn/Asterisk'   
import ExpenseInvoiceDel from './ExpenseInvoiceDel'
function ExpenseInvoiceEdit(props) {
    const { message } = App.useApp();
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'cbpdj_qy_id': '',
        'cbpdj_qy_name': '',
        'cbpdj_uid': '',
        'cbpdj_uname': '',
        'cbpdj_kh_id': '',
        'cbpdj_kh_name': '',
        'cbpdj_state': '',
        'cbpdj_image_file': '',
        'cbpdj_image_name': '',
        'cbpdj_id': '',
        'cbpdj_amount': '',
        'cbpdj_content': '',
        'cbpdj_bm_id': '',
        'cbpdj_bm_name': '',
        'cbpdj_ddzc_id': ''
    })
            const {data, isSuccess} = useFypdjUpdateQuery({fypdj_id:props.fypdj_id},{skip:!open,refetchOnMountOrArgChange:1});
    const [form] = Form.useForm();
    const [updateSave] = useFypdjUpdateSaveMutation();  
    const [defaultFileList, setDefaultFileList] = useState([]);
    
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            setInfo({
                    'fypdj_qy_id': data.Result.fypdj_qy_id, 
                'fypdj_qy_name': data.Result.fypdj_qy_name,
                'fypdj_uid': data.Result.fypdj_uid,
                'fypdj_uname': data.Result.fypdj_uname,
                'fypdj_ctime': data.Result.fypdj_ctime,
                'fypdj_kh_id': data.Result.fypdj_kh_id,
                'fypdj_kh_name': data.Result.fypdj_kh_name,
                'fypdj_state': data.Result.fypdj_state,
                'fypdj_image_file': data.Result.fypdj_image_file,
                'fypdj_image_name': data.Result.fypdj_image_name,
                'fypdj_id': data.Result.fypdj_id,
                'fypdj_amount': data.Result.fypdj_amount,
                'fypdj_content': data.Result.fypdj_content,
                'fypdj_bm_id': data.Result.fypdj_bm_id,
                'fypdj_bm_name': data.Result.fypdj_bm_name,
                'fypdj_ddzc_id': data.Result.fypdj_ddzc_id
            });
            setDefaultFileList(Array.isArray(data.Result.fypdj_image_name) ? data.Result.fypdj_image_name.filter(Boolean) : []);
            const imageNameArray = Array.isArray(data.Result.fypdj_image_name) 
            ? data.Result.fypdj_image_name.filter(Boolean)
            : (data.Result.fypdj_image_name ? [data.Result.fypdj_image_name] : []);
            const imageFileArray = Array.isArray(data.Result.fypdj_image_file)
                ? data.Result.fypdj_image_file.filter(Boolean)
                : (data.Result.fypdj_image_file ? [data.Result.fypdj_image_file] : []);

            const fileListForForm = imageNameArray.map((serverFileName, i) => {
                // 确保 URL 是完整路径
                // 根据 setupProxy.js，/api 代理到 fxapi.zzddww.com，用于访问图片
                let fullUrl = serverFileName;
                if (serverFileName.startsWith('http://')) {
                    // 完整 URL，直接使用
                    fullUrl = serverFileName;
                } else if (serverFileName.startsWith('/')) {
                    // 已经是相对路径，检查是否需要添加 /api 前缀
                    if (!serverFileName.startsWith('/api/') && !serverFileName.startsWith('/NeiZhangApi/')) {
                        fullUrl = `/api${serverFileName}`;
                    } else {
                        fullUrl = serverFileName;
                    }
                } else {
                    // 只是文件名，使用 /api/assets/images/application/ 路径
                    fullUrl = `${ASSETS_APPLICATION_BASE}/${serverFileName}`;
                }
                
                // 获取显示名称
                const displayName = imageFileArray[i] || undefined;
                
                return {
                    uid: `file-${i}-${serverFileName}`,
                    name: displayName || serverFileName || `文件${i + 1}`,
                    status: 'done',
                    url: fullUrl,
                    response: {
                        Result: serverFileName // 保存服务器文件名用于提交
                    }
                };
            });       
            form.setFieldsValue({
                'fypdj_qy_id': data.Result.fypdj_qy_id, 
                'fypdj_qy_name': data.Result.fypdj_qy_name,
                'fypdj_uid': data.Result.fypdj_uid,
                'fypdj_uname': data.Result.fypdj_uname,
                'fypdj_kh_id': data.Result.fypdj_kh_id,
                'fypdj_kh_name': data.Result.fypdj_kh_name,
                'fypdj_state': data.Result.fypdj_state,
                'fypdj_image_file': fileListForForm,
                'fypdj_image_name': imageNameArray,
                'fypdj_id': data.Result.fypdj_id,
                'fypdj_amount': data.Result.fypdj_amount,
                'fypdj_content': data.Result.fypdj_content,
                'fypdj_bm_id': data.Result.fypdj_bm_id,
                'fypdj_bm_name': data.Result.fypdj_bm_name,
                'fypdj_ddzc_id': data.Result.fypdj_ddzc_id
            })

        }
        
    }, [data, isSuccess,form])    

     return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.fypdj_kh_name}</a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #3366FF',borderLeft:'3px solid #3366FF'}}></Col>
                            <Col span={16} className={classes.row_top_middle} style={{color:'#3366FF',borderTop:'3px solid #3366FF'}}>费用票登记</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #3366FF',borderRight:'3px solid #3366FF'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #3366FF',color:'#3366FF'}}><Asterisk color='red'/> 费用单号</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <ExpenseListWithId
                                id={info.fypdj_ddzc_id}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                            />
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 费用票金额</Col>
                        <Col span={6}  className={classes.col_top_input} >
                            <span >￥</span>{Number(info.fypdj_amount).toLocaleString('zh-CN', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #3366FF'}}>
                            <ReportDeptSelect
                                yh_id={props.yh_id}
                                wrapperCol={{span:24}}
                                placeholder='请选择部门'
                                qy_id={props.qy_id}
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, fypdj_bm_id: e, fypdj_bm_name: f }))
                                }}
                                name="fypdj_bm_name"
                                defaultId={props.fypdj_bm_id ? String(props.fypdj_bm_id) : undefined}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366FF'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                           {info.fypdj_kh_name}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 上传费用票</Col>
                        <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #3366FF'}}>
                            <UploadPic
                                name='fypdj_image_file'
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, fypdj_image_file: e, fypdj_image_name: f }))
                                }}
                                maxCount={5}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                defaultFileList={defaultFileList}
                            />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366FF',borderBottom:'3px solid #3366FF'}}> 备注</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #3366FF'}}>
                            <Form.Item name='fypdj_content' noStyle>
                                <OCRTextArea
                                        value={info.fypdj_content}
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, fypdj_content: e.target.value }))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label} style={{borderBottom:'3px solid #3366FF'}}>提交记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #3366FF'}}>{info.fypdj_uname} {info.fypdj_ctime}</Col> 
                        <Col span={2} className={classes.col_middle_label} style={{borderBottom:'3px solid #3366FF'}}>编号</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #3366FF',borderBottom:'3px solid #3366FF'}}>{info.fypdj_id}</Col>    
                                                               
                    </Row>   
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    key='submit' 
                                    type='save' 
                                    onClick={() => {
                                        if(info.fypdj_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }
                                        if(info.fypdj_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.fypdj_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }        
                                        if(info.fypdj_image_file === ''){
                                                message.error('请上传费用票');
                                            return;
                                        }
                                        updateSave({
                                            'fypdj_qy_id': info.fypdj_qy_id,
                                            'fypdj_qy_name': info.fypdj_qy_name,
                                                'fypdj_uid': info.fypdj_uid,
                                            'fypdj_uname': info.fypdj_uname,
                                            'fypdj_kh_id': info.fypdj_kh_id,
                                            'fypdj_kh_name': info.fypdj_kh_name,
                                            'fypdj_state': info.fypdj_state,
                                            'fypdj_image_file': info.fypdj_image_file,
                                            'fypdj_image_name': info.fypdj_image_name,
                                            'fypdj_id': info.fypdj_id,
                                            'fypdj_amount': info.fypdj_amount,
                                            'fypdj_content': info.fypdj_content,
                                            'fypdj_bm_id': info.fypdj_bm_id,
                                            'fypdj_bm_name': info.fypdj_bm_name,
                                            'fypdj_ddzc_id': info.fypdj_ddzc_id                
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('修改成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('修改失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                />
                               
                                {props.fypdj_state === '1' && <ExpenseInvoiceDel fypdj_id={props.fypdj_id} />}
                               
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default ExpenseInvoiceEdit